import React from "react"
import { ThemeChanger } from "uxp/components"
const WidgetDesignerThemeChanger: React.FunctionComponent<{}> = (props) => {

    return <ThemeChanger
        rootElementId="widget-designer-widget-layout-container-rpxgtrs"
    />
}

export default WidgetDesignerThemeChanger